import React from "react";

import { Editor as DexEditor } from "@caelor/dex";

import { useDexData } from "../../../hooks/use-dex-data";
import { useStyleguideSetup } from "../../../hooks/use-styleguide-setup";
import { createDexColors } from "../dex-colors";
import { useCapabilitySet } from "../../../hooks/use-capability-set";

const Editor = () => {
  const { blocks, config } = useDexData();
  const { styleguideSetup, loading: styleguideSetupLoading } =
    useStyleguideSetup();

  const { isLoading, capabilitySet, isOrgAdmin } = useCapabilitySet();

  const { ownColors, dexColors } = createDexColors(styleguideSetup).reduce(
    (acc, color) => {
      if (color.type === "custom") {
        acc.ownColors.push(color);
      } else {
        acc.dexColors.push(color);
      }
      return acc;
    },
    { ownColors: [], dexColors: [] }
  );

  if (isLoading || styleguideSetupLoading) {
    return <></>;
  }

  return (
    <DexEditor
      onSave={(data) => {
        window.AP.confluence.saveMacro({
          blocks: JSON.stringify(data.blocks),
          config: JSON.stringify(data.config),
        });
        window.AP.dialog.close();
      }}
      onCancel={() => {
        window.AP.dialog.close();
      }}
      initialBlocks={blocks}
      initialConfig={config}
      licensingData={{
        capabilitySet,
        isOrgAdmin,
      }}
      ownColors={ownColors?.length ? ownColors : undefined}
      dexColors={dexColors?.length ? dexColors : undefined}
    />
  );
};

export default Editor;
